export default __webpack_public_path__ + "static/media/iconoServicios.ed950c67.svg";